class EventBus {
  /**
   * Initialize a new event bus instance.
   */
  constructor() {
    this.bus = document.createElement('div');
    this.bus.setAttribute('id', 'eventbus');
    this.bus.setAttribute('style', 'display:none;');
    document.body.appendChild(this.bus);

    // Pollyfil for ie
    if (typeof window.CustomEvent === 'function') return false;

    function CustomEvent(event, params) {
      const evt = document.createEvent('CustomEvent');
      const p = params || { bubbles: false, cancelable: false, detail: null };
      evt.initCustomEvent(event, p.bubbles, p.cancelable, p.detail);
      return evt;
    }

    window.CustomEvent = CustomEvent;
  }

  /**
   * Add an event listener.
   */
  addEventListener(event, callback) {
    this.bus.addEventListener(event, callback);
  }

  /**
   * Remove an event listener.
   */
  removeEventListener(event, callback) {
    this.bus.removeEventListener(event, callback);
  }

  /**
   * Dispatch an event.
   */
  dispatchEvent(event, detail = {}) {
    this.bus.dispatchEvent(new CustomEvent(event, { detail }));
  }

  /**
   * remove  and event listener.
   */
  once(name, callback) {
    const cb = (evt) => {
      callback(evt);
      this.bus.removeEventListener(name, cb);
    };
    this.bus.addEventListener(name, cb);
  }
}

// eslint-disable-next-line
let eventBus = window.EventBus;
if (eventBus == null) {
  eventBus = new EventBus();
  window.EventBus = eventBus;
  eventBus.instance = '__vue__';
}
export default eventBus;
